/** In-memory open-order cache for allowance aggregation — avoids extra API calls on Buy. */

const getStore = () => {
  if (typeof window !== 'undefined') {
    if (!window.__atsOpenOrdersCache) {
      window.__atsOpenOrdersCache = { byPair: {} };
    }
    return window.__atsOpenOrdersCache;
  }

  if (!getStore.moduleStore) {
    getStore.moduleStore = { byPair: {} };
  }
  return getStore.moduleStore;
};

const normalizePairKey = (pairName) => String(pairName ?? '').trim().toLowerCase();

const cloneOrders = (orders) => (Array.isArray(orders) ? orders.map((order) => ({ ...order })) : []);

export const setCachedOpenOrders = (pairName, orders) => {
  const key = normalizePairKey(pairName);
  if (!key) return;
  getStore().byPair[key] = cloneOrders(orders);
};

export const getCachedOpenOrders = (pairName) => {
  const key = normalizePairKey(pairName);
  if (!key) return [];
  return cloneOrders(getStore().byPair[key] ?? []);
};

export const upsertCachedOpenOrder = (pairName, order) => {
  const key = normalizePairKey(pairName);
  if (!key || !order) return;

  const store = getStore();
  const list = cloneOrders(store.byPair[key] ?? []);
  const orderId = order?.id ?? order?.order_id ?? order?.orderId;
  const index = list.findIndex((row) => Number(row?.id) === Number(orderId));

  if (index === -1) {
    list.unshift({ ...order });
  } else {
    list[index] = { ...list[index], ...order };
  }

  store.byPair[key] = list;
};

export const removeCachedOpenOrder = (pairName, orderId) => {
  const key = normalizePairKey(pairName);
  if (!key || orderId == null) return;

  const store = getStore();
  const list = cloneOrders(store.byPair[key] ?? []);
  store.byPair[key] = list.filter((row) => Number(row?.id) !== Number(orderId));
};
